module.exports = __webpack_public_path__ + "img/progress-three-done.4ae23ed4.png";